import CommentsAPI from '../api/CommentsAPI';
import {CommentsListRequest} from '../models/Comments/CommentModel';

class CommentsRepository {
  private commentsAPI = new CommentsAPI();

  public createComment(
    entityId: string,
    text: string,
    parentCommentId?: string,
  ) {
    return this.commentsAPI.createComment(entityId, text, parentCommentId);
  }

  public getComment(commentId: string) {
    return this.commentsAPI.getComment(commentId);
  }

  public editComment(commentId: string, text: string) {
    return this.commentsAPI.editComment(commentId, text);
  }

  public deleteComment(commentId: string) {
    return this.commentsAPI.deleteComment(commentId);
  }

  public getEntityComments(entityId: string, request: CommentsListRequest) {
    return this.commentsAPI.getEntityComments(entityId, request);
  }

  public getCommentReplies(commentId: string, request: CommentsListRequest) {
    return this.commentsAPI.getCommentReplies(commentId, request);
  }
}

export default CommentsRepository;
